import styles from './css/Style.module.css';
import './css/Style_loader.css';
import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SideMenu } from '../../../components/SideMenu';
import { NavBarSiteV1 } from '../../../components/NavBarSite/_v1/Index';
import { FooterSiteV1 } from '../../../components/FooterSite/v1';

import svg_pega_preco from '../../global/img/pega_preco.svg';
import { GLOBAL_LINKS_BAIXAR_APP, GLOBAL_LINKS_TOOME_MAPS_ADDRESS } from '../../global/links';
import { utils_search_childs } from '../../../components/utils/utils_search_childs';
import { SearchFilter } from '../../../components/SearchBar/SearchFilter';
import { API_END_POINT_FORM_CONTATO } from '../../../api/base';
import { LINKS_CENTRAL_DE_AJUDA, LINKS_EMAIL_CONTATO_TOOME, LINKS_NAV_APOIO_E_PATROCINEO, LINKS_NAV_PARA_CLIENTES, LINKS_NAV_PARA_MERCADOS, LINKS_TERMOS, LINKS_WHATSAPP } from '../../../Links';

function Central_Ajuda() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [state, setState] = useState(false)

    useEffect(() => {
        if (!state)
            setState(true);
        else {
            window.scrollTo({ top: 0, behavior: 'instant' });
            const message = searchParams.get('message');
            if (message) {
                alert(message);
                window.location.href = '#/opc_gerais/central_ajuda/'
            }

            const faqSection = document.getElementById('js_link_container_fac');
            const js_container_fac = document.getElementById('js_container_fac');
            const faq_topic = document.getElementsByName("faq_topic");
            if (faqSection !== null && js_container_fac !== null && faq_topic !== null) {
                js_container_fac.style.display = '';
                faqSection.addEventListener('click', function () {
                    js_container_fac.style.display = js_container_fac.style.display == '' ? 'block' : '';
                });
                faq_topic.forEach(function (topic) {
                    topic.addEventListener('click', function () {
                        const answer = this.nextElementSibling;
                        answer.style.display = (answer.style.display === 'none' || answer.style.display === '') ? 'block' : 'none';
                        if (!topic.classList.contains('faq_topic_sel'))
                            topic.classList.add('faq_topic_sel')
                        else
                            topic.classList.remove('faq_topic_sel')
                    });
                });
            }

            const furl_redirect = document.getElementById('furl_redirect');
            if (furl_redirect !== null)
                furl_redirect.value = window.location.href;
            function muralGetURLParam(param) {
                const parametros = window.location.href.substring(1).split('&');
                for (let i = 0; i < parametros.length; i++) {
                    const parametro = parametros[i].split(param + '=');
                    if (parametro.length == 2)
                        return parametro[1];
                }
                return null;
            }
            const msg_alerta = muralGetURLParam('msg_alert');
            if (msg_alerta !== null) {
                window.alert(msg_alerta.replace(/%20/g, " "));
                setTimeout(() => {
                    const gotoNextPage = window.parent.document.getElementById('gotoNextPage');
                    if (gotoNextPage !== null) {
                        gotoNextPage.style.animation = '.2s linear forwards gotoNextPageAnimeSlideClose';
                        gotoNextPage.src = '#/anim/';
                    }
                }, 30);

                setTimeout(() => {
                    window.parent.document.querySelectorAll("html")[0].style.overflow = "auto";
                    window.parent.scrollTo({ top: localStorage.getItem("LSTOR_Y_SCROLL_MURAL_TO_BACK_GROUND"), behavior: "instant" });
                }, 1);
            }

        }
    }, [state]);

    const RenderSearchFilter = () => {
        const searchFilterProps = {
            placeholder: 'O que está procurando?',
            onKeyUpCapture: (e) => {
                requestAnimationFrame(() => {
                    const CentralDeAjudaContainerDuvidasFrequentes = document.getElementById('CentralDeAjudaContainerDuvidasFrequentes');
                    if (CentralDeAjudaContainerDuvidasFrequentes.children[0].getAttribute('name') !== 'open') {
                        CentralDeAjudaContainerDuvidasFrequentes.children[0].click()
                    }
                    utils_search_childs('CentralDeAjudaContainerDuvidasFrequentes', 'CentralDeAjudaInputDuvidasFrequentes');
                })
            }
        }
        return <SearchFilter
            id={'CentralDeAjudaInputDuvidasFrequentes'}
            onKeyUpCapture={searchFilterProps.onKeyUpCapture}
            placeholder={searchFilterProps.placeholder}
        />
    }
    return (
        <>
            <div className="body" id="wait_api_load" style={{ display: 'none' }}>
                <svg className="ip" viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="grad1" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%" stopColor="#5ebd3e" />
                            <stop offset="33%" stopColor="#ffb900" />
                            <stop offset="67%" stopColor="#f78200" />
                            <stop offset="100%" stopColor="#e23838" />
                        </linearGradient>
                        <linearGradient id="grad2" x1="1" y1="0" x2="0" y2="0">
                            <stop offset="0%" stopColor="#e23838" />
                            <stop offset="33%" stopColor="#973999" />
                            <stop offset="67%" stopColor="#009cdf" />
                            <stop offset="100%" stopColor="#5ebd3e" />
                        </linearGradient>
                    </defs>
                    <g fill="none" strokeLinecap="round" strokeWidth="3">
                        <g className="ip__track" stroke="#ddd">

                            <polygon points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                            <polygon style={{ transform: 'translate(50px, 50px)' }}
                                points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                        </g>
                        <g strokeDasharray="100 300">
                            <polygon className="ip__worm1" stroke="url(#grad2)"
                                points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                            <polygon className="ip__worm2" stroke="url(#grad1)" style={{ transform: 'translate(50px, 50px)' }}
                                points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                        </g>
                    </g>
                </svg>
                <p>Enviando. Aguarde...</p>
            </div>

            <main className={`${styles.container_geral_central_de_ajuda}`}>

                <NavBarSiteV1 />

                <section className={styles.contatoWrapper}>
                    <div>
                        <h1>Como o <b>TooMe</b> pode te ajudar?</h1>
                        <p>
                            Estamos prontos para ouvir você. Aqui você pode falar conosco de várias formas, por whatsapp, por e-mail, ou se preferir preenchendo o formulário, mas antes, dá uma olhada nas perguntas frequêntes, vai que sua dúvida está lá 😉.
                        </p>
                    </div>

                    <div className={styles.gridContato}>
                        <div>
                            <h2>📱 WhatsApp</h2>
                            <p>Converse diretamente com a nossa equipe.</p>
                            <a
                                href={LINKS_WHATSAPP}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Falar no WhatsApp
                            </a>
                        </div>

                        <div>
                            <h2>📧 E-mail</h2>
                            <p>Envie sua mensagem para nosso time de atendimento.</p>
                            <a href={LINKS_EMAIL_CONTATO_TOOME}>
                                Enviar E-mail
                            </a>
                        </div>

                        <div>
                            <h2>🤝 Mercado Parceiro</h2>
                            <p>veja se sua dúvida já está respondida.</p>
                            <Link to={LINKS_NAV_PARA_MERCADOS()}>
                                Perguntas Frequentes
                            </Link>
                        </div>

                        <div>
                            <h2>🌟 Apoio Patrocínio</h2>
                            <p>Quer apoiar o TooMe ou se tornar patrocinador?</p>
                            <Link to={LINKS_NAV_APOIO_E_PATROCINEO()}>
                                Oportunidades de Apoio
                            </Link>
                        </div>
                    </div>

                </section>

                <div className={styles.formularioSimples}>
                    <h2>Se preferir, preencha o formulário e retornaremos em breve.</h2>
                    <form
                        method="post"
                        action={API_END_POINT_FORM_CONTATO}
                    >
                        <label htmlFor="name">Nome</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Seu nome completo"
                            required
                        />

                        <label htmlFor="email">E-mail</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="seuemail@exemplo.com"
                            required
                        />

                        <label htmlFor="message">Mensagem</label>
                        <textarea
                            id="message"
                            name="message"
                            rows="3"
                            placeholder="Digite sua mensagem..."
                            required
                        ></textarea>

                        <button type="submit" className={styles.btnEnviarSimples}>Enviar</button>
                    </form>
                    <p> Ao se cadastrar, você aceita nossa <Link to={LINKS_TERMOS}>Política de privacidade</Link> sobre os dados fornecidos.
                    </p>
                </div>

                <section className={styles.IframeContainer}>
                    <b className={styles.IframeTitle}>Onde estamos:</b>
                    <p>Incubadora Sprint da UTFPR-TD
                        Rua Cristo Rei, 19 - Bloco "E", Sala E-001 - Vila Becker, Toledo - PR.</p>
                    <iframe
                        className={styles.Iframe}
                        src={GLOBAL_LINKS_TOOME_MAPS_ADDRESS}
                        title="Localização do TooMe no Google Maps"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        style={{ border: 0 }}
                    />
                </section>


                <section className={styles.faq}>
                    <div className={`${styles.container_input}`}><RenderSearchFilter className={`${styles.container_input}`} /></div>
                    <details className={styles.faqBox} id='CentralDeAjudaContainerDuvidasFrequentes'>
                        <summary className={styles.subtitulo} onClick={(e) => {
                            e.target.setAttribute('name', e.target.getAttribute('name') !== 'open' ? 'open' : '');
                        }}>Dúvidas frequentes</summary>

                        <details>
                            <summary>O que é o TooMe?</summary>
                            <p>O TooMe é um aplicativo que permite aos usuários buscar e compartilhar ofertas e promoções de supermercados, ganhando benefícios e com várias funcionalidades relevantes para o dia a dia de compras, ajudando-os a economizar tempo e dinheiro em suas compras diárias. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>O TooMe é gratuito?</summary>
                            <p>Sim, o TooMe é um aplicativo gratuito para download e uso. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>Como funcionam os jogos e desafios no TooMe?</summary>
                            <p>Com os jogos e desafios no TooMe, você ganha pontos que podem ser trocados por benefícios e, posteriormente, recompensas exclusivas. Além disso, você aprende práticas ambientais e de economia. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>Para que servem os pontos no TooMe?</summary>
                            <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, e de forma temporária, utilizamos pontos como recompensas. Esses pontos podem ser ganhos ao participar de jogos, programas de benefícios e desafios no TooMe, e utilizados para participar de sorteios (quando disponível), realizar buscas avançadas de preços e, futuramente, obter recompensas e produtos exclusivos dentro do aplicativo. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>Como posso compartilhar ofertas no TooMe?</summary>
                            <p>Você pode compartilhar ofertas no TooMe tirando uma foto e digitando os detalhes da oferta, que será então disponibilizada para outros usuários do aplicativo. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>Eu ganho algo ao compartilhar ofertas no TooMe?</summary>
                            <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, você ganha pontos postando uma oferta. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>O TooMe é seguro?</summary>
                            <p>Sim, o TooMe prioriza a segurança dos dados dos usuários e implementa várias medidas de proteção para garantir a privacidade e segurança das informações, conforme nossos <Link style={{ color: '#d65616e2' }} to={LINKS_TERMOS}>Termos de Uso e Políticas de privacidade</Link>.</p>
                        </details>

                        <details>
                            <summary>Como posso encontrar as melhores ofertas perto de mim?</summary>
                            <p>O TooMe utiliza as notificações do seu dispositivo para mostrar ofertas e promoções em supermercados próximos a você. Além disso, você pode personalizar a localidade que quer ver as ofertas, mudando a cidade na página inicial do aplicativo. Você também pode buscar produtos diretamente na barra de pesquisa e ativar as notificações clicando na opção "Perfil" no canto inferior direito da página principal do aplicativo. <Link style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</Link>.</p>
                        </details>

                        <details>
                            <summary>O TooMe funciona em todas as cidades?</summary>
                            <p>O TooMe já tem capacidade para funcionar em todo o Paraná e em alguns outros estados do país. No entanto, para testar o desempenho inicial, o lançamento está previsto apenas para a cidade de Toledo, no Paraná. Mas fique atento: o TooMe está continuamente trabalhando para expandir sua cobertura e incluir ofertas e promoções de supermercados em diversas cidades. Verifique a disponibilidade na sua região acessando a página principal do aplicativo. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>Posso usar o TooMe para fazer compras online?</summary>
                            <p>Atualmente, o TooMe é focado em buscas de ofertas e promoções em supermercados, mas futuras atualizações podem incluir funcionalidades para compras online.</p>
                        </details>

                        <details>
                            <summary>Como posso resgatar meus pontos?</summary>
                            <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, os pontos podem ser convertidos em consultas de preço e sorteios (quando disponível) e, posteriormente, em produtos exclusivos ou descontos que vão estar listados no aplicativo. Basta acessar a seção dos seus pontos. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                        </details>

                        <details>
                            <summary>O que acontece se eu encontrar uma oferta incorreta no TooMe?</summary>
                            <p>Você pode alertar o usuário sobre o imprevisto ou, em casos mais graves de postagens indevidas, denunciar ofertas incorretas diretamente na postagem. Nossa equipe irá revisar e remover a postagem caso necessário. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link>.</p>
                        </details>

                        <details>
                            <summary>Posso sugerir novos recursos para o TooMe?</summary>
                            <p>Sim, estamos sempre abertos a sugestões e feedback dos nossos usuários. Você pode enviar suas ideias através da opção <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda</Link>.</p>
                        </details>

                        <details>
                            <summary>O TooMe coleta meus dados pessoais?</summary>
                            <p>O TooMe coleta apenas os dados necessários para fornecer um serviço eficaz e seguro, para que você obtenha todas as ofertas e promoções da sua localidade e tenha a melhor experiência possível no aplicativo. Todos os dados são tratados de acordo com os nossos <Link style={{ color: '#d65616e2' }} to={LINKS_TERMOS}>Termos de Uso e Políticas de privacidade</Link>.</p>
                        </details>

                        <details>
                            <summary>Como o TooMe aborda a sustentabilidade?</summary>
                            <p>O TooMe atua nas três dimensões da sustentabilidade e contribui para diversos Objetivos de Desenvolvimento Sustentável (ODS) por meio das funcionalidades oferecidas no aplicativo. Você pode conferir, detalhadamente, acessando os <Link style={{ color: 'green' }} to={`..${LINKS_NAV_PARA_CLIENTES()}`}>IMPACTOS POSITIVOS</Link>, na seção <Link style={{ color: '#ff5500' }} to={`..${LINKS_NAV_PARA_CLIENTES()}`}>sobre nós</Link>.</p>
                        </details>

                        <details>
                            <summary>Como o TooMe se diferencia de outros aplicativos de compras?</summary>
                            <p>O TooMe se destaca pela combinação única de compartilhamento colaborativo com foco na experiência do usuário e várias funcionalidades exclusivas, como: Mural de ofertas, mapa das ofertas, lista inteligente, encartes e ofertas por proximidade, e muitos outros, proporcionando uma abordagem inovadora para compras. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'> Baixe</a> o aplicativo e conheça todas as funcionalidades do TooMe!</p>
                        </details>

                        <details>
                            <summary>Como posso entrar em contato com o suporte do TooMe?</summary>
                            <p>Você pode entrar em contato com o suporte do TooMe diretamente através do aplicativo ou enviando um e-mail para nossa equipe de atendimento ao cliente. Acesse a <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda</Link>.</p>
                        </details>
                    </details>
                </section>


                <div className={`${styles.img_oracio_atend}`}>
                    <img
                        src={svg_pega_preco}
                        alt="Imagem do mascote do TooMe com nome de: Pega Preço"
                        loading='lazy'
                        width={240}
                        height={240}
                    />
                    <p>Pensou em ir ao mercado?<b> Pensou no TooMe!</b></p>
                    <p>Caso necessário, entre em contato pelo e-mail <b>contato@tonomercado.com.br</b></p>
                </div>
                <SideMenu />
                <FooterSiteV1 />
            </main>

        </>
    );
}

export default Central_Ajuda;